import Axios from 'axios';


var headers = {

    'Content-Type': 'application/json'

}

export default {

    login(data) {
        Axios.defaults.baseURL = data?.shoplink;
        delete data.shoplink;
        const BASE_URL = '/public/api';
        return Axios.post(BASE_URL + '/auth/login', data, { headers: headers });
    },
    logout() {

    }

}